export function defaultContextFunction() {
   console.log(`Function ${arguments.callee.name} called outside of context`);
}
export async function defaultContextPromiseFunction() {
   console.log(`Function ${arguments.callee.name} called outside of context`);
}
export default defaultContextFunction;